<style scoped lang="scss">
    .shop_bind {
        padding-bottom: 3rem;
        text-align: center;
        .van-loading {
            margin: 15px auto;
        }
    }
    .shop_bind_falid {
        height: 4rem;
        line-height: 4rem;
        color: #ff0000;
        text-align: center;
    }
    .shop_bind_success {
        height: 4rem;
        line-height: 4rem;
        color: #00dc63;
        text-align: center;
    }
    .shop_bind_dialog {
        .title {
            padding: 5px 0;
            font-size: 14px;
            text-align: center; 
            color: #999;
        }
        .van-cell {
            padding: 5px 15px;
        }
        .van-button {
            width: 100%;
        }
    }
</style>

<template>
    <div class="Show">
        <div>
            <van-nav-bar
                title="门店绑定"
                left-text=""
            />
            <div class="cmain">
                <van-cell-group>
                    <van-cell title="门店名称" :value="shopInfo.name" />
                    <van-cell title="联系电话" :value="shopInfo.tel" />
                    <van-cell title="地址:" :label="shopInfo.addressDetail" />
                    <div class="shop_bind" v-if="!popupIsShow && !isSuccess">
                        <van-loading type="spinner" color="#1c82d4" />
                        <span>门店正在绑定中，请稍候...</span>
                    </div>
                    <div class="shop_bind_falid" v-if="popupIsShow || !isSuccess">{{ bindText }}</div>
                    <div class="shop_bind_success" v-if="!popupIsShow && isSuccess">{{ bindText }}</div>
                </van-cell-group>
            </div>
            <van-popup class="shop_bind_dialog" v-model="popupIsShow" position="bottom" :close-on-click-overlay="false">
                <div class="">
                    <van-cell-group>
                        <van-cell>
                            <div class="title">您还未登录，请先登录!</div>
                        </van-cell>
                        <van-cell>
                            <van-button type="primary" @click="toLogin()">立即登录</van-button>
                        </van-cell>
                        <van-cell>
                            <van-button type="warning" @click="toRegist()">立即注册</van-button>
                        </van-cell>
                    </van-cell-group>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import areaData from '@/js/area.js'
    export default {
        name: "shopBind",
        data() {
            return {
                shopId: 0,
                shopInfo: {},
                isSuccess: false,
                popupIsShow: false,
                isBindOrUnbind: false,
                bindText: ""
            }
        },
        watch: {
            "$store.state.user"(v) {
                this.bindShop()
            }
        },
        async mounted() {
            await areaData.getAreasData()
            this.showH5Loading();
            this.getShopInfo()
            setTimeout(() => {
                if (!this.isBindOrUnbind) {
                    this.bindShop()
                }
            }, 20000)
        },
        methods: {
            //获取店铺信息
            getShopInfo() {
                this.shopId = this.$route.params.id
                this.axios.get(window.consts.apis.shopInfo + '?Id=' + this.shopId).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        let item = res.result
                        this.shopInfo = item
                        let addressTrance = areaData.getAreaNames([item.address.province, item.address.city, item.address.area]).join(" ")
                        this.shopInfo.addressDetail = `${addressTrance} ${item.address.detail}`
                    } else {
                        this.$toast.fail(res.error.message)
                    }
                }).catch(res => {
                    this.hideH5Loading();
                    this.$toast.fail(res.error.message)
                    return false
                })
            },
            bindShop() {
                this.isBindOrUnbind = true
                if (!this.$store.state.user || this.$store.state.user.id <= 0) {
                    this.bindText = "您还未登录，请先登录!"
                    this.popupIsShow = true
                    this.isSuccess = false
                } else {
                    this.popupIsShow = false
                    // 执行绑定
                    let shopId = this.shopId
                    if (shopId && shopId > 0) {
                        this.$axios.post(window.consts.apis.bindShop, { shopId: shopId }).then(sr => {
                            if (sr.success) {
                                this.isSuccess = true
                                this.bindText = "门店绑定成功!"
                                this.$toast.success("门店绑定成功!")
                            } else {
                                this.isSuccess = false
                                this.bindText = "门店绑定失败，请重新绑定!"
                                this.$toast.fail("门店绑定失败，请重新绑定!")
                            }
                        })
                    }
                }
            },
            toLogin() {
                this.$router.push({ path:'/m/login', query: { shopId: this.shopId } });
            },
            toRegist() {
                this.$router.push({ path:'/m/register', query: { shopId: this.shopId } });
            }
        }
    }
</script>